(() => {
  const setCartCount = (count) => {
    document.querySelectorAll('[data-kl-cart-count]').forEach((element) => {
      element.textContent = String(count || 0);
    });
  };

  const syncHeaderOffsets = () => {
    const topHeader = document.querySelector('[data-kl-top-header]');
    // Use the sticky top bar's *bottom* edge in the viewport, not just its height:
    // at scroll-top the announcement bar pushes the bar down, so the bar bottom is
    // (announcement height + bar height). The mobile drawer is positioned at this
    // offset; using bare height would tuck its first item behind the bar.
    const offset = topHeader ? Math.max(0, Math.ceil(topHeader.getBoundingClientRect().bottom)) : 0;
    document.documentElement.style.setProperty('--kl-header-top-height', `${offset}px`);
  };

  const syncHeaderScrollState = () => {
    const isScrolled = window.scrollY > 24;
    document.querySelector('[data-kl-top-header]')?.classList.toggle('is-scrolled', isScrolled);
    document.querySelector('[data-kl-main-header]')?.closest('.shopify-section')?.classList.toggle('is-scrolled', isScrolled);
  };

  const decorateHeaderSections = () => {
    document.querySelector('[data-kl-top-header]')?.closest('.shopify-section')?.classList.add('kl-header-top-section');
    document.querySelector('[data-kl-main-header]')?.closest('.shopify-section')?.classList.add('kl-header-nav-section');
  };

  const applyLiveHeaderFixes = () => {
    if (!document.getElementById('kl-live-header-fixes')) {
      const style = document.createElement('style');
      style.id = 'kl-live-header-fixes';
      style.textContent = `
        .kl-header-top__wordmark,
        .kl-header-top__wordmark-svg {
          display: none !important;
        }

        .kl-header-top__burger {
          display: none !important;
          align-items: center !important;
          justify-content: center !important;
          flex: 0 0 auto !important;
          order: 4 !important;
          min-width: 42px !important;
          min-height: 40px !important;
          margin: 0 !important;
          padding: 0 11px !important;
          border: 1px solid rgba(46, 29, 21, 0.16) !important;
          border-radius: 999px !important;
          background: #fff !important;
          color: #2e1d15 !important;
        }

        @media (max-width: 1024px) {
          .kl-header-top__burger {
            display: inline-flex !important;
          }
        }

        .kl-header-top__burger .kl-nav__burger-label {
          display: none !important;
        }

        .kl-journal-preview__media {
          background-image: none !important;
        }

        .kl-journal-preview__media img {
          display: block !important;
          width: 100% !important;
          max-width: 100% !important;
          height: 100% !important;
          object-fit: cover !important;
          opacity: 1 !important;
          color: inherit !important;
          font-size: inherit !important;
        }

        @media (max-width: 749px) {
          .kl-header-top {
            flex-wrap: nowrap !important;
            gap: 8px !important;
          }

          .kl-header-top__logo-symbol {
            max-width: 46px !important;
            max-height: 34px !important;
          }

          .kl-header-top__search {
            flex: 1 1 auto !important;
            min-width: 0 !important;
          }

          .kl-brand-story .story-grid {
            position: relative !important;
            display: grid !important;
            gap: var(--kl-space-3) !important;
            overflow: visible !important;
            background: transparent !important;
            box-shadow: none !important;
          }

          .kl-brand-story .story-panel {
            margin: 0 !important;
            background: var(--kl-color-surface) !important;
            border: 1px solid var(--kl-color-line) !important;
            box-shadow: var(--kl-shadow-md) !important;
            backdrop-filter: none !important;
            -webkit-backdrop-filter: none !important;
          }

          .kl-brand-story .story-media {
            position: relative !important;
            inset: auto !important;
            width: 100% !important;
            height: auto !important;
            aspect-ratio: 4 / 3 !important;
            order: -1 !important;
            border-radius: var(--kl-radius-xl) !important;
            box-shadow: var(--kl-shadow-md) !important;
          }

          .kl-brand-story .story-media__img {
            object-position: center 45% !important;
          }

          .kl-brand-story .story-media-inner {
            background: linear-gradient(180deg, rgba(46, 29, 21, 0.02) 0%, rgba(46, 29, 21, 0.24) 100%) !important;
          }
        }
      `;
      document.head.appendChild(style);
    }

    document.querySelectorAll('.kl-header-top__wordmark, .kl-header-top__wordmark-svg').forEach((element) => element.remove());
  };

  let cartRequest = null;

  const fetchCart = () => {
    if (!window.routes?.cart_url) return Promise.resolve(null);
    if (cartRequest) return cartRequest;

    cartRequest = fetch(`${window.routes.cart_url}.js`, {
      headers: { Accept: 'application/json' },
    })
      .then((response) => response.json())
      .catch((error) => {
        console.error(error);
        return null;
      })
      .finally(() => {
        cartRequest = null;
      });

    return cartRequest;
  };

  const refreshCartCount = (cartData) => {
    if (typeof cartData?.item_count === 'number') {
      setCartCount(cartData.item_count);
      return Promise.resolve(cartData);
    }

    return fetchCart().then((cart) => {
      if (cart) setCartCount(cart.item_count);
      return cart;
    });
  };

  const openCartDrawer = () => {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) {
      document.dispatchEvent(new CustomEvent('cart:open'));
      return;
    }

    const hoveredLink = document.querySelector('[data-kl-cart-link]:hover');
    const trigger = hoveredLink instanceof HTMLElement ? hoveredLink : document.activeElement;
    const open = () => cartDrawer.open(trigger instanceof HTMLElement ? trigger : undefined);

    if (typeof subscribe === 'function' && typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      Promise.resolve(publish(PUB_SUB_EVENTS.cartUpdate, { source: 'kl-header' }))
        .catch((error) => {
          console.error(error);
        })
        .finally(open);
      return;
    }

    open();
  };

  const init = () => {
    decorateHeaderSections();
    applyLiveHeaderFixes();
    syncHeaderOffsets();
    syncHeaderScrollState();
    refreshCartCount();

    window.openCartDrawer = openCartDrawer;
    window.addEventListener('resize', syncHeaderOffsets);
    window.addEventListener('scroll', () => {
      syncHeaderOffsets();
      syncHeaderScrollState();
    }, { passive: true });

    if (document.fonts?.addEventListener) {
      document.fonts.addEventListener('loadingdone', syncHeaderOffsets);
    }

    if (window.ResizeObserver) {
      const observer = new ResizeObserver(() => syncHeaderOffsets());
      document.querySelectorAll('[data-kl-top-header], [data-kl-main-header]').forEach((element) => observer.observe(element));
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => refreshCartCount(event?.cartData));
    }

    document.addEventListener('cart:updated', (event) => refreshCartCount(event.detail));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
